import * as React from 'react'
import TextareaAutosize from 'react-autosize-textarea'
import styled, { InterpolationValue } from 'styled-components'
import { rem, placeholder } from 'polished'
import { Text } from '../Text'
import { Division } from '../Division'
import { Block } from '../Layout/Block'
import { FontWeight } from '$utils/theme'

interface Props extends React.TextareaHTMLAttributes<any> {
  className?: string
  placeholder?: string
  label?: string
  name?: string
  onBlur?: () => void
  hasLine?: boolean
}

const StyledTextarea = styled(TextareaAutosize).attrs({})<Props>`
  width: 100%;
  padding: ${p => rem(p.theme.sizes.tiny)} ${p => rem(p.theme.sizes.mini)} ${p => rem(p.theme.sizes.tiny)}
    ${p => rem(p.theme.sizes.none)};
  ${p => p.theme.font.base(FontWeight.regular)};
  ${p => placeholder({ color: p.theme.colors.grey }) as InterpolationValue};

  &:focus {
    border-color: ${p => p.theme.colors.darkGrey};
    caret-color: ${p => p.theme.colors.darkGrey};
    outline: none;
  }
  height: ${p => rem(p.theme.sizes.small)};
  border: none;
  margin-top: ${p => rem(p.theme.sizes.tiny)};

  ${p =>
    !p.hasLine &&
    `
    border: 1px solid ${p.theme.colors.lightGrey}
    border-radius: 25px;
    padding: 1rem;
    height: ${rem(p.theme.sizes.huge)};
  `};
`

export const Textarea: React.SFC<Props> = props => {
  return (
    <Block>
      <Text weight="medium">{props.label}</Text>
      <StyledTextarea {...props} rows={3} data-hj-allow />
      {props.hasLine && <Division marginTop="small" color="lightGrey" />}
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Textarea/Textarea.tsx